import React from "react";
import classes from "./InputCheckbox.module.scss";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";

const InputCheckbox = ({
  label = null,
  checked = null,
  onChange = null,
  ...rest
}) => {
  return (
    <FormControlLabel
      {...rest}
      onChange={onChange}
      className={classes.MainCheckbox}
      control={
        <Checkbox
          {...rest}
          className={classes.CheckedBox}
          onChange={onChange}
          checked={checked}
          sx={{
            borderColor: "#ced4da",
            color: "##d81818",
            "&.Mui-checked": {
              color: "#662D91",
            },
          }}
        />
      }
      label={label}
    />
  );
};

export default InputCheckbox;
